import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertCircle, CheckCircle2 } from "lucide-react";

interface ImportFeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  successCount: number;
  errorCount: number;
  totalLines: number;
}

export function ImportFeedbackModal({
  isOpen,
  onClose,
  successCount,
  errorCount,
  totalLines,
}: ImportFeedbackModalProps) {
  const hasErrors = errorCount > 0;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            {hasErrors ? (
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
                <AlertCircle className="h-6 w-6 text-yellow-600" />
              </div>
            ) : (
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                <CheckCircle2 className="h-6 w-6 text-green-600" />
              </div>
            )}
            <DialogTitle className="text-xl">
              {hasErrors ? "Importação Parcial" : "Importação Concluída"}
            </DialogTitle>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {hasErrors ? (
            <>
              <DialogDescription className="text-base space-y-3">
                <div className="flex items-center gap-2">
                  <span className="text-green-600 font-semibold text-lg">
                    {successCount}
                  </span>
                  <span className="text-gray-700">
                    {successCount === 1
                      ? "exceção foi atualizada com sucesso!"
                      : "exceções foram atualizadas com sucesso!"}
                  </span>
                </div>

                <div className="flex items-start gap-2 bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded">
                  <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                  <div className="space-y-1">
                    <p className="text-gray-800 font-medium">
                      {errorCount === 1
                        ? `${errorCount} registro apresentou erro`
                        : `${errorCount} registros apresentaram erro`}
                    </p>
                    <p className="text-sm text-gray-600">
                      Por favor, revise os dados e importe novamente apenas os
                      registros que apresentaram problema. Um arquivo com os erros
                      foi baixado automaticamente.
                    </p>
                  </div>
                </div>

                <div className="text-sm text-gray-500 pt-2">
                  Total processado: {totalLines}{" "}
                  {totalLines === 1 ? "linha" : "linhas"}
                </div>
              </DialogDescription>
            </>
          ) : (
            <DialogDescription className="text-base space-y-2">
              <div className="flex items-center gap-2 text-gray-700">
                <CheckCircle2 className="h-5 w-5 text-green-600" />
                <span>
                  Todas as {totalLines}{" "}
                  {totalLines === 1 ? "exceção foi processada" : "exceções foram processadas"}{" "}
                  com sucesso!
                </span>
              </div>
            </DialogDescription>
          )}
        </div>

        <DialogFooter>
          <Button onClick={onClose} className="w-full sm:w-auto">
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
